module.exports = __webpack_public_path__ + "media/images/shark/Shark5-2e3369267605686ecf1993d9c1489f6e.png";